<template>
	<div>
		Vous avez terminé votre formation. Cliquez sur le bouton "Suivant" en bas à droite.
	</div>
</template>

<script>
    export default {
               mounted()       {
                       window.parent.postMessage("Audit 2", "*");
               },
    };
</script>

<style scoped>
div {
	position: absolute;
	text-align: center;
	margin-top: 20%;
	font-weight: bolder;
	font-size: x-large;
	height: 300px;
}
</style>
